import type { OsobyPodnikatelRozsireneDto } from '@gov-nx/api';
import { is, propEq } from '@gov-nx/core/types';

export const getMyInvolvement = (data: OsobyPodnikatelRozsireneDto[]) =>
	data
		.map((item) => {
			const myInvolvement = item.angazovaneOsoby?.filter(
				propEq('mojeAngazovanost', true)
			);
			return myInvolvement?.length
				? { ...item, angazovaneOsoby: myInvolvement }
				: null;
		})
		.filter(is);
